export const personalInfo = {
  name: 'Federico Gonzalez',
  nameEn: 'Federico Gonzalez',
  role: 'Desarrollador Full-Stack y DevOps',
  roleEn: 'Senior Full-Stack Developer & DevOps Engineer',
  taglines: [
    'Orquestando infraestructura robusta, creando experiencias de usuario fluidas.',
    'Uniendo el gap entre DevOps escalable y desarrollo Full-Stack de alto rendimiento.',
  ],
  taglinesEn: [
    'Orchestrating robust infrastructure, crafting seamless user experiences.',
    'Bridging the gap between scalable DevOps and high-performance Full-Stack development.',
  ],
  bio: `Desarrollador full stack y DevOps proactivo, creativo y orientado a resultados con más de 10 años de experiencia en desarrollo de software. Apasionado por las nuevas tecnologías y el aprendizaje continuo.`,
  bioEn: `Proactive, creative, and results-oriented Full-Stack Developer and DevOps Engineer with over 10 years of software development experience. Passionate about new technologies and continuous learning.`,
  email: 'federico.gonzalez@devecoop.com',
  location: 'Argentina',
  languages: ['Español (Nativo)', 'Inglés (Avanzado)'],
  hobbies: [
    { icon: 'events', label: 'Organizador Eventos Software Libre', labelEn: 'Free Software Events Organizer', detail: 'FLISoL, PyCon, PyDay', detailEn: 'FLISoL, PyCon, PyDay', url: null },
    { icon: 'kickboxing', label: 'Kick Boxing', labelEn: 'Kick Boxing', detail: null, detailEn: null, url: null },
    { icon: 'cooking', label: 'Cocina', labelEn: 'Cooking', detail: '@al.horno.con.papa', url: 'https://alhornoconpapa.com.ar' },
    { icon: 'coop', label: 'Cooperativista', labelEn: 'Co-op Member', detail: 'Socio de Devecoop', detailEn: 'Member of Devecoop', url: 'https://devecoop.com' },
  ],
  githubStats: {
    repos: 58,
    followers: 41,
    stars: 8500,
    organizations: [
      { name: 'Devecoop', url: 'https://github.com/Devecoop' },
      { name: 'PyAr', url: 'https://github.com/PyAr' },
      { name: 'eventoL', url: 'https://github.com/eventoL' },
      { name: 'CaFeLUG', url: 'https://github.com/CaFeLUG' },
      { name: 'GNUtn', url: 'https://github.com/GNUtn' },
      { name: 'lelylan', url: 'https://github.com/lelylan' },
    ],
  },
  social: {
    github: 'https://github.com/Fedeg',
    gitlab: 'https://gitlab.com/FedeG/',
    linkedin: 'https://www.linkedin.com/in/fedeg1/',
  },
}

export const skills = {
  'Lenguajes de Programación': ['Python', 'JavaScript', 'Ruby', 'Java', 'Bash', 'C', 'C++', 'Go'],
  'Frameworks y Herramientas': ['Django', 'React', 'React-Native', 'Angular', 'Node.js', 'Redux', 'GraphQL', 'SASS', 'LESS', 'Docker', 'Docker Compose', 'Terraform', 'Ansible', 'Webpack', 'd3.js'],
  'Bases de Datos': ['PostgreSQL', 'MySQL', 'MongoDB', 'CouchDB', 'Elasticsearch'],
  'DevOps e Infraestructura': ['AWS (EC2, S3, RDS, Lambda)', 'Digital Ocean', 'Docker', 'Terraform', 'Ansible', 'Nginx', 'Kafka'],
}

export const experience = [
  {
    role: 'Partner & Developer',
    roleEn: 'Partner & Developer',
    company: 'Devecoop',
    companyUrl: 'https://devecoop.com',
    period: 'Oct 2016 - Presente',
    periodEn: 'Oct 2016 - Present',
    location: 'Argentina',
    description: 'Devecoop es una cooperativa de software de la cual soy socio desde 2016. Trabajamos con diferentes lenguajes y tecnologías, siendo Python la tecnología principal. Desde 2016 hasta el presente, trabajo desde Devecoop en otros empleos como staff augmentation o desarrollando nuestros propios proyectos.',
    descriptionEn: 'Devecoop is a software cooperative where I have been a partner since 2016. We work with different languages and technologies, with Python as the main technology. From 2016 to present, I work through Devecoop on other jobs as staff augmentation or developing our own projects.',
    current: true,
    isOwn: true,
    tech: ['Python', 'Django', 'React', 'Docker', 'AWS', 'PostgreSQL'],
    highlights: [
      'Socio desde 2016',
      'Desarrollo de Gantiem, sistema de gestión de colas en tiempo real',
      'Múltiples proyectos para clientes internacionales',
    ],
    highlightsEn: [
      'Partner since 2016',
      'Development of Gantiem, a real-time queue management system',
      'Multiple projects for international clients',
    ],
  },
  {
    role: 'Desarrollador Full Stack',
    roleEn: 'Senior Full-Stack Engineer',
    company: 'Batuta',
    companyUrl: 'https://batuta.com',
    period: 'Sept 2022 - Feb 2026',
    location: 'San Francisco (Remote)',
    description: 'Batuta orquesta el futuro de la ciberseguridad a través de la Inteligencia de Endpoints. Parte de la Comunidad Global de Innovadores del Foro Económico Mundial y del Centro de Ciberseguridad, con sede en San Francisco. Trabajando en un producto de ciberseguridad con responsabilidades full stack, transformando datos de endpoints en información accionable.',
    descriptionEn: 'Batuta orchestrates the future of cybersecurity through Endpoint Intelligence. Part of the World Economic Forum Global Innovators Community and the Cybersecurity Center, based in San Francisco. Working on a cybersecurity product with full-stack responsibilities, transforming endpoint data into actionable insights.',
    isOwn: false,
    tech: ['Node.js', 'React.js', 'Kafka', 'Elasticsearch', 'MongoDB', 'Docker', 'AWS'],
    highlights: [
      'Plataforma de inteligencia de endpoints - World Economic Forum Global Innovators',
      'Analítica en tiempo real manejando telemetría de alto volumen',
      'Arquitectura y desarrollo de sistemas de detección de amenazas',
    ],
    highlightsEn: [
      'Endpoint intelligence platform - World Economic Forum Global Innovators',
      'Real-time analytics handling high-volume telemetry',
      'Architecture and development of threat detection systems',
    ],
  },
  {
    role: 'Desarrollador Backend y DevOps',
    roleEn: 'Backend & DevOps Engineer',
    company: 'Kilimo',
    companyUrl: 'https://kilimo.com',
    period: 'Sep 2020 - Jul 2022',
    location: 'Argentina (Remote)',
    description: 'Kilimo es una plataforma de Gestión Efectiva de Riego que entrega resultados de rendimiento y calidad con menos recursos. Diferentes servicios para recopilar y analizar datos sobre campos y el medio ambiente (datos climáticos, satelitales, sensores) y calcular el balance hídrico y recomendaciones de riego.',
    descriptionEn: 'Kilimo is an Effective Irrigation Management platform that delivers performance and quality results with fewer resources. Different services to collect and analyze field and environmental data (climate, satellite, sensor data) and calculate water balance and irrigation recommendations.',
    isOwn: false,
    tech: ['Django', 'Python', 'Celery', 'Terraform', 'AWS (S3, EC2, RDS)', 'Nginx'],
    highlights: [
      'Microservicios para agregación de datos satelitales y climáticos',
      'Algoritmos de balance hídrico para recomendaciones de riego en tiempo real',
      'Infraestructura como Código con Terraform',
    ],
    highlightsEn: [
      'Microservices for satellite and climate data aggregation',
      'Water balance algorithms for real-time irrigation recommendations',
      'Infrastructure as Code with Terraform',
    ],
  },
  {
    role: 'Desarrollador Mobile y Backend',
    roleEn: 'Mobile & Backend Developer',
    company: 'Deportify',
    companyUrl: null,
    period: 'Dic 2019 - May 2020',
    location: 'Argentina',
    description: 'Deportify es una aplicación móvil para la reserva y gestión de clubes de fútbol y tenis. La aplicación fue desarrollada en React Native y Django.',
    descriptionEn: 'Deportify is a mobile application for booking and managing soccer and tennis clubs. The app was developed in React Native and Django.',
    isOwn: false,
    tech: ['React Native', 'Django', 'Python'],
    highlights: [
      'App móvil multiplataforma para reservas deportivas',
      'Desarrollo full stack mobile + backend',
    ],
    highlightsEn: [
      'Cross-platform mobile app for sports reservations',
      'Full-stack mobile + backend development',
    ],
  },
  {
    role: 'Desarrollador Frontend',
    roleEn: 'Frontend Developer',
    company: 'Receptiviti Inc. (Canadá)',
    companyUrl: 'https://receptiviti.com',
    period: 'Dic 2018 - Dic 2019',
    location: 'Canadá (Remote)',
    description: 'Creación de gráficos usando d3 y React-vis para visualización de datos, agregar responsividad a diseños estáticos, mejoras de consultas GraphQL. Creación de página web completa desde bocetos. Trabajando con prácticas Ágiles como TDD, Integración Continua y Demos.',
    descriptionEn: 'Creating charts using d3 and React-vis for data visualization, adding responsiveness to static designs, GraphQL query improvements. Building complete web pages from sketches. Working with Agile practices like TDD, Continuous Integration and Demos.',
    isOwn: false,
    tech: ['React.js', 'GraphQL', 'Docker', 'Selenium', 'd3.js'],
    highlights: [
      'Visualización de datos con d3.js y React-vis',
      'Optimización de consultas GraphQL',
      'Desarrollo guiado por pruebas y CI/CD',
    ],
    highlightsEn: [
      'Data visualization with d3.js and React-vis',
      'GraphQL query optimization',
      'Test-driven development and CI/CD',
    ],
  },
  {
    role: 'Desarrollador Full Stack',
    roleEn: 'Full-Stack Developer',
    company: 'Proyecto Mobile App',
    companyUrl: null,
    period: 'Ago 2017 - Ago 2019',
    location: 'Argentina',
    description: 'Aplicación desarrollada en React, Redux, React Native, Cordova para iOS y Android y también para Electron (aplicación de escritorio multiplataforma).',
    descriptionEn: 'Application developed in React, Redux, React Native, Cordova for iOS and Android and also for Electron (cross-platform desktop application).',
    isOwn: false,
    tech: ['React', 'Redux', 'React Native', 'Cordova', 'Electron', 'JavaScript'],
    highlights: [
      'App multiplataforma: iOS, Android y desktop',
      'Arquitectura con React y Redux',
    ],
    highlightsEn: [
      'Cross-platform app: iOS, Android and desktop',
      'Architecture with React and Redux',
    ],
  },
  {
    role: 'Desarrollador Mobile',
    roleEn: 'Mobile Developer',
    company: 'Mobile Mall App',
    companyUrl: null,
    period: 'Jul 2017',
    location: 'Argentina',
    description: 'Aplicación Mobile Mall desarrollada en React Native para iOS y Android usando código JavaScript.',
    descriptionEn: 'Mobile Mall application developed in React Native for iOS and Android using JavaScript.',
    isOwn: false,
    tech: ['React Native', 'JavaScript'],
    highlights: [
      'App nativa para iOS y Android con React Native',
    ],
    highlightsEn: [
      'Native iOS and Android app with React Native',
    ],
  },
  {
    role: 'Desarrollador Full Stack',
    roleEn: 'Full-Stack Developer',
    company: 'Gantiem (Devecoop)',
    companyUrl: 'https://devecoop.com',
    period: 'Oct 2016 - 2017',
    location: 'Argentina',
    description: 'Gantiem es un sistema de gestión de colas creado por Devecoop. Aplicación de gestión de colas en tiempo real desarrollada usando Django, Python, React, Redux, Django Channels (eventos en tiempo real), websockets, API REST, Swagger, Webpack y Nginx.',
    descriptionEn: 'Gantiem is a queue management system created by Devecoop. Real-time queue management application developed using Django, Python, React, Redux, Django Channels (real-time events), websockets, REST API, Swagger, Webpack and Nginx.',
    isOwn: true,
    tech: ['Django', 'Python', 'React', 'Redux', 'Django Channels', 'WebSockets', 'REST API', 'Swagger', 'Webpack', 'Nginx'],
    highlights: [
      'Sistema de gestión de colas en tiempo real',
      'WebSockets con Django Channels para actualizaciones instantáneas',
      'API REST documentada con Swagger',
    ],
    highlightsEn: [
      'Real-time queue management system',
      'WebSockets with Django Channels for instant updates',
      'REST API documented with Swagger',
    ],
  },
  {
    role: 'Desarrollador Full Stack',
    roleEn: 'Full-Stack Developer',
    company: 'Exo',
    companyUrl: null,
    period: 'Dic 2013 - Oct 2016',
    location: 'Argentina',
    description: 'Proyectos IoT para gestión de eventos en tiempo real y control de hardware desde sensores. Los proyectos fueron desarrollados usando MQTT, Node.js, C++ y WebSockets. Algunos proyectos fueron desarrollados usando Python, Golang y CouchDB.',
    descriptionEn: 'IoT projects for real-time event management and hardware control from sensors. Projects were developed using MQTT, Node.js, C++ and WebSockets. Some projects were developed using Python, Golang and CouchDB.',
    isOwn: false,
    tech: ['MQTT', 'Node.js', 'C++', 'WebSockets', 'Python', 'Go', 'CouchDB'],
    highlights: [
      'Proyectos IoT para gestión de eventos en tiempo real',
      'Control de hardware desde sensores',
      'Arquitecturas con MQTT y WebSockets',
    ],
    highlightsEn: [
      'IoT projects for real-time event management',
      'Hardware control from sensors',
      'Architectures with MQTT and WebSockets',
    ],
  },
]

export const projects = [
  {
    id: 'encryptr',
    title: 'Encryptr',
    titleEn: 'Encryptr',
    role: 'Creador & Desarrollador Principal',
    roleEn: 'Creator & Lead Developer',
    description: 'Administrador de contraseñas de código abierto con más de 1,600 estrellas en GitHub. Gestión segura de credenciales con cifrado robusto.',
    descriptionEn: 'Open-source password manager with over 1,600 stars on GitHub. Secure credential management with robust encryption.',
    category: ['open-source', 'full-stack'],
    tech: ['JavaScript', 'Cifrado', 'Node.js'],
    links: [
      { label: 'GitHub', url: 'https://github.com/Fedeg/Encryptr' },
    ],
    featured: true,
  },
  {
    id: 'alhornoconpapa',
    title: 'al.horno.con.papa',
    titleEn: 'al.horno.con.papa',
    role: 'Creador & Desarrollador',
    roleEn: 'Creator & Developer',
    description: 'Blog de cocina con recetas, fotos e integración con Instagram API. Construido con React y Python, con generación de imágenes por IA.',
    descriptionEn: 'Cooking blog with recipes, photos and Instagram API integration. Built with React and Python, with AI image generation.',
    category: ['full-stack'],
    tech: ['React', 'Python', 'Instagram API', 'IA'],
    links: [
      { label: 'Sitio Web', url: 'https://alhornoconpapa.com.ar' },
      { label: 'GitHub', url: 'https://github.com/Fedeg/al.horno.con.papa' },
    ],
    featured: true,
  },
  {
    id: 'anush',
    title: 'anush_cuidarte_posts',
    titleEn: 'anush_cuidarte_posts',
    role: 'Creador & Desarrollador',
    roleEn: 'Creator & Developer',
    description: 'Sitio web de bienestar y cuidados personales con integración de Instagram. Desarrollado con React y Python.',
    descriptionEn: 'Wellness and self-care website with Instagram integration. Built with React and Python.',
    category: ['full-stack'],
    tech: ['React', 'Python', 'Instagram API'],
    links: [
      { label: 'GitHub', url: 'https://github.com/Fedeg/anush_cuidarte_posts' },
    ],
    featured: false,
  },
  {
    id: 'eventol',
    title: 'Eventol',
    titleEn: 'Eventol',
    role: 'Co-Fundador & Contribuidor Principal',
    roleEn: 'Co-Founder & Lead Contributor',
    description: 'Eventol es un software de gestión de conferencias e install fest desarrollado inicialmente para gestionar FLISoL (el evento install fest más popular de Argentina). Es software libre y soy co-fundador. Usado por la Comunidad Python Argentina (PyCon, PyDay, etc.).',
    descriptionEn: 'Eventol is conference and install fest management software initially developed to manage FLISoL (the most popular install fest in Argentina). It is free software and I am co-founder. Used by the Python Argentina Community (PyCon, PyDay, etc.).',
    category: ['open-source', 'full-stack'],
    tech: ['Django', 'Python', 'React.js', 'Docker Compose'],
    links: [
      { label: 'GitHub Organization', url: 'https://github.com/eventoL' },
      { label: 'Sitio Web', url: 'https://eventol.org' },
    ],
    featured: true,
  },
  {
    id: 'eventol-landing',
    title: 'eventol.org Landing',
    titleEn: 'eventol.org Landing',
    role: 'Contribuidor Frontend',
    roleEn: 'Frontend Contributor',
    description: 'Página web institucional de EventoL, el software de gestión de conferencias y eventos de software libre.',
    descriptionEn: 'EventoL institutional website, the free software conference and event management platform.',
    category: ['open-source', 'full-stack'],
    tech: ['React', 'JavaScript'],
    links: [
      { label: 'GitHub', url: 'https://github.com/eventoL/eventol.org' },
      { label: 'Sitio', url: 'https://eventol.org' },
    ],
    featured: false,
  },
  {
    id: 'gantiem',
    title: 'Gantiem (Devecoop)',
    titleEn: 'Gantiem (Devecoop)',
    role: 'Desarrollador Full-Stack Principal',
    roleEn: 'Lead Full-Stack Developer',
    description: 'Sistema de gestión de colas en tiempo real con actualizaciones instantáneas via WebSockets, API REST robusta y documentación completa con Swagger.',
    descriptionEn: 'Real-time queue management system with instant updates via WebSockets, robust REST API and complete Swagger documentation.',
    category: ['full-stack'],
    tech: ['Django', 'Python', 'React', 'Redux', 'Django Channels', 'WebSockets', 'REST API', 'Swagger', 'Webpack', 'Nginx'],
    links: [
      { label: 'GitHub Profile', url: 'https://github.com/Fedeg' },
    ],
    featured: true,
  },
  {
    id: 'pancreas-artificial',
    title: 'TDC - Páncreas Artificial',
    titleEn: 'TDC - Artificial Pancreas',
    role: 'Investigador & Desarrollador Embebido',
    roleEn: 'Researcher & Embedded Developer',
    description: 'Proyecto de investigación con CONICET sobre páncreas artificial utilizando Arduino y sistemas embebidos para control de infusión de insulina.',
    descriptionEn: 'Research project with CONICET on artificial pancreas using Arduino and embedded systems for insulin infusion control.',
    category: ['iot'],
    tech: ['Arduino', 'C', 'C++', 'Sistemas Embebidos'],
    links: [
      { label: 'GitHub', url: 'https://github.com/Fedeg/TDC-pancreas-artificial' },
    ],
    featured: true,
  },
  {
    id: 'machine-learning',
    title: 'UTN - Machine Learning',
    titleEn: 'UTN - Machine Learning',
    role: 'Estudiante & Desarrollador',
    roleEn: 'Student & Developer',
    description: 'Trabajos prácticos y proyectos de Machine Learning realizados durante la carrera de Ingeniería en Sistemas en UTN FRBA.',
    descriptionEn: 'Practical assignments and Machine Learning projects done during the Systems Engineering degree at UTN FRBA.',
    category: ['training'],
    tech: ['Python', 'Jupyter', 'Scikit-learn', 'Pandas'],
    links: [
      { label: 'GitHub', url: 'https://github.com/Fedeg/UTN-FRBA-machine-learning' },
    ],
    featured: false,
  },
  {
    id: 'react-workshops',
    title: 'Capacitaciones React',
    titleEn: 'React Workshops',
    role: 'Instructor Técnico',
    roleEn: 'Technical Instructor',
    description: 'Capacitaciones avanzadas de React & Redux para empresas como Mercado Libre, Tecso y la Federación Facttic. Cubriendo state management, hooks y arquitecturas frontend escalables.',
    descriptionEn: 'Advanced React & Redux workshops for companies like Mercado Libre, Tecso and Facttic Federation. Covering state management, hooks and scalable frontend architectures.',
    category: ['training'],
    tech: ['React 16.8', 'Redux', 'React Hooks'],
    links: [
      { label: 'Mercado Libre Workshop', url: 'https://github.com/Fedeg/react-workshop-16-2/' },
      { label: 'Facttic Workshop', url: 'https://github.com/Fedeg/react-redux-workshop' },
      { label: 'Tecso Hooks Workshop', url: 'https://github.com/Fedeg/react-workshop-16-8-with-hooks' },
    ],
    featured: true,
  },
  {
    id: 'meanjs',
    title: 'MEAN.js - Docker Contribution',
    titleEn: 'MEAN.js - Docker Contribution',
    role: 'Contribuidor Open Source',
    roleEn: 'Open Source Contributor',
    description: 'Contribuí con el deployment usando Docker Compose al repositorio oficial de MEAN.js. Pull request fusionado en código estable agregando Dockerfile y compose para producción, y actualizando Dockerfile para desarrollo y producción.',
    descriptionEn: 'Contributed Docker Compose deployment to the official MEAN.js repository. Merged pull request adding Dockerfile and compose for production, and updating Dockerfile for development and production.',
    category: ['devops', 'open-source'],
    tech: ['Docker', 'Docker Compose', 'MEAN Stack'],
    links: [
      { label: 'GitHub Profile', url: 'https://github.com/Fedeg' },
    ],
    featured: false,
  },
  {
    id: 'leylan',
    title: 'Leylan IoT Platform',
    titleEn: 'Leylan IoT Platform',
    role: 'Contribuidor DevOps e Infraestructura',
    roleEn: 'DevOps & Infrastructure Contributor',
    description: 'Plataforma IoT en la nube con arquitectura de microservicios. Miembro activo de la organización Leylan, contribuyendo en resolución de bugs, reporte de issues y deployment con Docker Compose.',
    descriptionEn: 'Cloud IoT platform with microservices architecture. Active member of the Leylan organization, contributing to bug fixing, issue reporting and deployment with Docker Compose.',
    category: ['iot', 'devops', 'open-source'],
    tech: ['Microservicios', 'Docker', 'Docker Compose', 'MQTT', 'Arquitectura IoT Cloud'],
    links: [
      { label: 'GitLab Profile', url: 'https://gitlab.com/FedeG/' },
    ],
    featured: false,
  },
  {
    id: 'batuta',
    title: 'Plataforma de Inteligencia de Endpoints',
    titleEn: 'Endpoint Intelligence Platform',
    role: 'Ingeniero Full-Stack Senior',
    roleEn: 'Senior Full-Stack Engineer',
    description: 'Arquitectura y desarrollo de un producto de ciberseguridad en tiempo real manejando telemetría de alto volumen desde endpoints corporativos para identificar proactivamente amenazas de seguridad.',
    descriptionEn: 'Architecture and development of a real-time cybersecurity product handling high-volume telemetry from corporate endpoints to proactively identify security threats.',
    category: ['enterprise', 'full-stack'],
    tech: ['Node.js', 'React.js', 'Kafka', 'Elasticsearch', 'MongoDB', 'Docker', 'AWS'],
    links: [
      { label: 'LinkedIn', url: 'https://www.linkedin.com/in/fedeg1/' },
    ],
    featured: true,
  },
  {
    id: 'kilimo',
    title: 'Motor de Balance Hídrico',
    titleEn: 'Water Balance Engine',
    role: 'Ingeniero Backend e Infraestructura',
    roleEn: 'Backend & Infrastructure Engineer',
    description: 'Microservicios para agregar y procesar datos satelitales, climáticos y de sensores para calcular balance hídrico y recomendar riego en tiempo real para agricultura de precisión.',
    descriptionEn: 'Microservices to aggregate and process satellite, climate and sensor data to calculate water balance and recommend real-time irrigation for precision agriculture.',
    category: ['devops', 'enterprise'],
    tech: ['Django', 'Python', 'Celery', 'Terraform', 'AWS (S3, EC2, RDS)', 'Nginx'],
    links: [
      { label: 'LinkedIn', url: 'https://www.linkedin.com/in/fedeg1/' },
    ],
    featured: true,
  },
]

export const openSource = [
  {
    title: 'Technical Book Reviewer @ Packt Publishing',
    titleEn: 'Technical Book Reviewer @ Packt Publishing',
    period: '2019 - 2023',
    items: [
      'Practical Python Programming for IoT (2019) - Revisión técnica y pruebas de código',
      'Hands-On Internet of Things with MQTT (2019) - Revisión técnica y pruebas de código',
    ],
    itemsEn: [
      'Practical Python Programming for IoT (2019) - Technical review and code testing',
      'Hands-On Internet of Things with MQTT (2019) - Technical review and code testing',
    ],
  },
  {
    title: 'Capacitaciones Corporativas',
    titleEn: 'Corporate Training',
    period: '2018 - 2020',
    items: [
      'Capacitación React 16.8 con Redux y Hooks para Tecso (Sep 2019)',
      'Capacitación React 16.8 con Redux para Facttic (May 2019)',
      'Capacitación React 16.2 para Mercado Libre (Sep - Dic 2018)',
    ],
    itemsEn: [
      'React 16.8 with Redux and Hooks training for Tecso (Sep 2019)',
      'React 16.8 with Redux training for Facttic (May 2019)',
      'React 16.2 training for Mercado Libre (Sep - Dic 2018)',
    ],
  },
  {
    title: 'Educación',
    titleEn: 'Education',
    period: '2011 - 2024',
    items: [
      'Ingeniero en Sistemas de Información - UTN (Feb 2011 - Dic 2024)',
      'Analista en Sistemas de Información - UTN (Feb 2011 - Mar 2023)',
    ],
    itemsEn: [
      'Information Systems Engineer - UTN (Feb 2011 - Dec 2024)',
      'Information Systems Analyst - UTN (Feb 2011 - Mar 2023)',
    ],
  },
  {
    title: 'Certificaciones',
    titleEn: 'Certifications',
    period: '2016',
    items: [
      'MongoDB for Python Developers - Mongo University',
      'MongoDB for Node.js Developers - Mongo University',
      'MongoDB for DBAs - Mongo University',
    ],
    itemsEn: [
      'MongoDB for Python Developers - Mongo University',
      'MongoDB for Node.js Developers - Mongo University',
      'MongoDB for DBAs - Mongo University',
    ],
  },
]
